import Api from "./Api";

const endpoint = "/qr";
export default {
    generate(options) {
        return Api.postData(endpoint + "/generate", options);
    }
};
